import { render } from "./MdlTecnicos.vue?vue&type=template&id=b74c151c&scoped=true"
import script from "./MdlTecnicos.vue?vue&type=script&lang=js"
export * from "./MdlTecnicos.vue?vue&type=script&lang=js"

import "./MdlTecnicos.vue?vue&type=style&index=0&id=b74c151c&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74c151c"]])

export default __exports__